import React from 'react';
import type { MilestoneDeliveryStatus } from '../types';
import { MilestoneConflictActionButton } from './MilestoneConflictActionButton';

interface MilestoneRemediationActionsProps {
  deliveryStatus?: MilestoneDeliveryStatus;
  isPerson: boolean;
  attestLabel: string;
  preparingLabel: string;
  conflictLabel: string;
  onAttest: () => void;
  onOpenConflict: () => void;
  isPreparing?: boolean;
  compact?: boolean;
  dataTestId?: string;
  attestDataTestId?: string;
}

/** Shared attestation and conflict actions shown while a milestone is being remedied. */
export function MilestoneRemediationActions({
  deliveryStatus,
  isPerson,
  attestLabel,
  preparingLabel,
  conflictLabel,
  onAttest,
  onOpenConflict,
  isPreparing = false,
  compact = false,
  dataTestId,
  attestDataTestId
}: MilestoneRemediationActionsProps) {
  return (
    <div
      className="d-flex flex-column flex-sm-row gap-2 flex-shrink-0"
      data-testid={dataTestId}
    >
      <button
        type="button"
        className={`btn ${compact ? 'btn-sm' : ''} ${isPerson ? 'btn-primary' : 'btn-success'}`}
        data-testid={attestDataTestId}
        disabled={isPreparing}
        onClick={onAttest}
      >
        <i className="feather-flag me-1" />
        {isPreparing ? preparingLabel : attestLabel}
      </button>
      <MilestoneConflictActionButton
        deliveryStatus={deliveryStatus}
        compact={compact}
        onClick={onOpenConflict}
      >
        {conflictLabel}
      </MilestoneConflictActionButton>
    </div>
  );
}
